import * as olSphere from "ol/sphere";
import UserSetting from "sccUserSetting";
//const ol= require("ol");
const olSourceVector = require("ol/source/Vector").default;
const source = new olSourceVector();
const olLayerVector = require("ol/layer/Vector").default;
const olStyleStyle = require("ol/style/Style").default;
const olStyleFill = require("ol/style/Fill").default;
const olStyleStroke = require("ol/style/Stroke").default;
const olStyleCircle = require("ol/style/Circle").default;
const log = require("loglevel");

class MapMeasure {
  constructor(olMap) {
    this.map = olMap.map;

    // holds the active/inactive status of the line/area measure tool
    this.lineActive = false;
    this.areaActive = false;

    // holds the value of line/area measure tool
    this.lineValue = 0;
    this.areaValue = 0;
    this.setLineValue("Draw line on map");
    this.setAreaValue("Draw area on map");
    this.draw = null;
    this.vector = new olLayerVector({
      source: source,
      style: new olStyleStyle({
        fill: new olStyleFill({
          color: "rgba(255, 255, 255, 0.2)",
        }),
        stroke: new olStyleStroke({
          color: "#ffcc33",
          width: 2,
        }),
        image: new olStyleCircle({
          radius: 7,
          fill: new olStyleFill({
            color: "#ffcc33",
          }),
        }),
      }),
    });
  }

  addInteraction(measureType) {
    const $this = this;
    this.removeInteraction().then(() => {
      $this.setIntractionParameters(measureType);
    });
  }

  setIntractionParameters(measureType) {
    const $this = this;
    const type = measureType == "area" ? "Polygon" : "LineString";
    const olInteractionDraw = require("ol/interaction/Draw").default;
    this.draw = new olInteractionDraw({
      source: source,
      type: type,
      style: new olStyleStyle({
        fill: new olStyleFill({
          color: "rgba(255, 255, 255, 0.2)",
        }),
        stroke: new olStyleStroke({
          color: "rgba(0, 0, 0, 0.5)",
          lineDash: [10, 10],
          width: 2,
        }),
        image: new olStyleCircle({
          radius: 7,
          stroke: new olStyleStroke({
            color: "rgba(0, 0, 0, 0.7)",
            width: 2,
          }),
          fill: new olStyleFill({
            color: "rgba(255, 255, 255, 0.2)",
          }),
        }),
      }),
    });
    this.map.addInteraction(this.draw);
    // this.listener;
    this.draw.on(
      "drawstart",
      function (evt) {
        // set sketch
        sketch = evt.feature;

        $this.listener = sketch.getGeometry().on("change", function (evt) {
          var geom = evt.target;
          const Polygon = require("ol/geom/Polygon").default;
          const LineString = require("ol/geom/LineString").default;

          if (geom instanceof Polygon) {
            $this.setAreaValue(formatArea(geom));
          } else if (geom instanceof LineString) {
            $this.setLineValue(formatLength(geom));
          }
        });
      },
      this
    );

    this.draw.on(
      "drawend",
      function () {
        // unset sketch
        sketch = null;
      },
      this
    );
  }

  setLineValue(value) {
    this.lineValue = value;
  }

  setAreaValue(value) {
    this.areaValue = value;
  }

  removeInteraction() {
    const $this = this;
    this.setAreaValue(0);
    this.setLineValue(0);

    if (this.draw != null) {
      // removing the intraction with timeout to prevent
      // map from zooming in when double clicked to finish
      // drawing
      return new Promise((resolve) =>
        setTimeout(() => {
          $this.map.removeInteraction($this.draw);
          $this.draw = null;
          resolve();
        }, 251)
      );
    } else {
      return Promise.resolve();
    }
  }

  resetMeasureControls() {
    this.removeInteraction();
    this.areaActive = false;
    this.lineActive = false;
  }

  toggleLineControl() {
    this.areaActive = false;
    this.lineActive = !this.lineActive;
    this.lineActive ? this.addInteraction("line") : this.removeInteraction();
  }

  toggleAreaControl() {
    log.info("testing area measure");
    this.lineActive = false;
    this.areaActive = !this.areaActive;
    this.areaActive ? this.addInteraction("area") : this.removeInteraction();
  }
}

/**
 * Currently drawn feature.
 * @type {ol.Feature}
 */
var sketch;

/**
 * Format length output.
 * @param {ol.geom.LineString} line The line.
 * @return {string} The formatted length.
 */

function formatLength(line) {
  let format = UserSetting.get("speed_format");
  let length = olSphere.getLength(line); // Length in meters
  let feet = length * 3.28084;
  let output;

  switch (format) {
    case "KPH":
      length > 100 // 0.1 km
        ? (output = Math.round((length / 1000) * 100) / 100 + " km")
        : (output = Math.round(length * 100) / 100 + " m");
      break;
    case "MPH":
      feet > 528 // 0.1 mi
        ? (output = Math.round((feet / 5280) * 100) / 100 + " mi")
        : (output = Math.round(feet * 100) / 100 + " ft");
      break;
    case "KNOTS":
      feet > 607.611 // 0.1 nm
        ? (output = Math.round((feet / 6076.11) * 100) / 100 + " nm")
        : (output = Math.round(feet * 100) / 100 + " ft");
      break;
    default:
      output = Math.round(length * 100) / 100 + " m";
  }
  return output;
}

/**
 * Format area output.
 * @param {ol.geom.Polygon} polygon The polygon.
 * @return {string} Formatted area.
 */

function formatArea(polygon) {
  //const olSphere= require("ol/sphere").default;
  let format = UserSetting.get("speed_format");
  let area = olSphere.getArea(polygon);
  let squareFeet = area * 10.7639;
  let output;

  switch (format) {
    case "KPH":
      area > 10000 // 0.01 km²
        ? (output = Math.round((area / 1000000) * 100) / 100 + " km²")
        : (output = Math.round(area * 100) / 100 + " m²");
      break;
    case "MPH":
      squareFeet > 278784 // 0.01 mi²
        ? (output = Math.round((squareFeet / 27878400) * 100) / 100 + " mi²")
        : (output = Math.round(squareFeet * 100) / 100 + " ft²");
      break;
    case "KNOTS":
      squareFeet > 369190.93 // 0.01 nm²
        ? (output = Math.round((squareFeet / 36919093.29) * 100) / 100 + " nm²")
        : (output = Math.round(squareFeet * 100) / 100 + " ft²");
      break;
    default:
      output = Math.round(area * 100) / 100 + " m²";
  }
  return output;
}

export default MapMeasure;
